import React from 'react';
import PropTypes from 'prop-types';
import s from './Field.styles';

const Field = ({ label, text, status, ...rest }) => (
  <s.Field {...rest}>
    <s.FieldLabel>{label}</s.FieldLabel>
    <s.FieldText status={status}>{text}</s.FieldText>
  </s.Field>
);

Field.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  status: PropTypes.string,
};

Field.defaultProps = {};

export default React.memo(Field);
